import { createTeleporter } from 'react-teleporter'

export const HeaderTeleport = createTeleporter()
